import { render, staticRenderFns } from "./WtTableCellLongText.vue?vue&type=template&id=118fdae9&scoped=true&lang=pug&"
import script from "./WtTableCellLongText.vue?vue&type=script&lang=js&"
export * from "./WtTableCellLongText.vue?vue&type=script&lang=js&"
import style0 from "./WtTableCellLongText.vue?vue&type=style&index=0&id=118fdae9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118fdae9",
  null
  
)

export default component.exports